import React from "react";
import { string, number, oneOf, func, object } from "prop-types";
import { connect } from "react-redux";
import get from "lodash/get";

import RightArrow from "../icons/right-arrow";

import "./headline.m.css";

const Headline = ({
  text = "",
  headlineType = 1,
  headerLevel = 1,
  headlineDesign = "",
  className = "",
  onClick,
  rightArrowColor = "#f4511e",
  publisherAttributes
}) => {
  const HeaderTag = "h" + headerLevel;

  const withbackgroundDom = () => (
    <span className="withbg-text text" onClick={onClick}>
      {text}
    </span>
  );

  const simpleDom = () => {
    return text;
  };

  const withArrow = () => (
    <React.Fragment>
      <span
        className={`with-arrow text ${publisherAttributes.lang === "en" ? "en-with-arrow" : ""}`}
        styleName={publisherAttributes.lang === "en" ? "en-with-arrow" : ""}
        onClick={onClick}
      >
        {text}
      </span>
      <RightArrow arrowColor={rightArrowColor} />
    </React.Fragment>
  );

  const headlineDom = () => {
    switch (headlineDesign) {
      case "withbackground":
        return withbackgroundDom();
      case "witharrow":
        return withArrow();
      default:
        return simpleDom();
    }
  };

  return (
    <React.Fragment>
      <HeaderTag
        styleName={`headline headline-type-${headlineType} ${headlineDesign}`}
        className={`headline headline-type-${headlineType} ${headlineDesign} ${className}`}
        onClick={onClick}
      >
        {headlineDom()}
      </HeaderTag>
    </React.Fragment>
  );
};

Headline.propTypes = {
  text: string,
  headlineType: number,
  headerLevel: number,
  headlineDesign: oneOf(["", "crossline", "withbackground", "witharrow"]),
  className: string,
  rightArrowColor: string,
  onClick: func,
  publisherAttributes: object
};

const mapStateToProps = state => {
  return {
    publisherAttributes: get(state, ["qt", "config", "publisher-attributes"], {})
  };
};

export default connect(mapStateToProps, null)(Headline);
